import { Map } from 'immutable';

import * as t from '../../actions/submitAQuestionActionTypes';

const initialState = Map({
  isUserQuestionsLoading: false,
  submittedQuestions: [],
  deleteStatusMessage: '',
  selectedQuestion: {},
  message: {
    type: '',
    text: '',
  },
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case t.SET_USER_CREATED_QUESTIONS:
      return state.set('submittedQuestions', action.questions);

    case t.SET_IS_USER_QUESTIONS_LOADING:
      return state.set('isUserQuestionsLoading', action.isLoading);

    case t.SET_USER_QUESTIONS_MESSAGE:
      return state.set('message', action.message);

    case t.SET_DELETE_STATUS_MESSAGE:
      return state.set('deleteStatusMessage', action.message);

    case t.SET_SELECTED_QUESTION:
      return state.set('selectedQuestion', action.question);

    default:
      return state;
  }
};

export default reducer;
